import React, {useState, useCallback} from 'react';

function ShareButton({slug, quizId, answerId}) {
    const [copied, setCopied] = useState(false);

    const buildShareUrl = useCallback(() => {
        const origin = (typeof window !== 'undefined' && window.location && window.location.origin) || '';
        if (answerId) {
            return origin + '/answer-sheet/' + encodeURIComponent(answerId);
        }
        const params = new URLSearchParams();
        if (quizId) params.set('quizid', quizId);
        const query = params.toString();
        return origin + '/learn/' + encodeURIComponent(slug) + (query ? '?' + query : '');
    }, [slug, quizId, answerId]);

    const handleClick = useCallback(async () => {
        const url = buildShareUrl();
        if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
            try {
                await navigator.share({url});
                return;
            } catch (e) {
                // user cancelled or share failed — fall through to clipboard
            }
        }
        try {
            if (navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(url);
                setCopied(true);
                setTimeout(() => setCopied(false), 1800);
            }
        } catch (e) {
            // give up silently
        }
    }, [buildShareUrl]);

    return (
        <button type="button" className="learn-share-btn" onClick={handleClick} aria-label="Share">
            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                <circle cx="18" cy="5" r="3"></circle>
                <circle cx="6" cy="12" r="3"></circle>
                <circle cx="18" cy="19" r="3"></circle>
                <line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line>
                <line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>
            </svg>
            <span>{copied ? 'Copied' : 'Share'}</span>
        </button>
    );
}

export default ShareButton;
